import React, { useState } from "react";
import SignUp from "../Registration";
import Login from "../Login";
import CustomDialog from '../../../../components/Dialog/Dialog';
import { AuthPopupProps } from '../../types';


const AuthPopup: React.FC<AuthPopupProps> = ({ open, handleClose, isSignupMode = false }) => {
  const [isSignupModeState, setIsSignupMode] = useState<boolean>(isSignupMode);
  const [showOtp, setShowOtp] = useState<boolean>(false);
  
  // Conditional close behavior: if showOtp is true, onClose should be empty
  const handleConditionalClose = () => {
    if (!showOtp) {
      handleClose();
    }
  };
  
  return (
    <CustomDialog
      open={open}
      handleClose={handleConditionalClose}
      isHeader={false}
      width="486px"
      fullWidth={true}
    >
      <div>
        {isSignupModeState ? (
          <SignUp setSignup={setIsSignupMode} />
        ) : (
          <Login 
            setSignup={setIsSignupMode} 
            showOtp={showOtp}
            setShowOtp={setShowOtp}
            handleClose={handleClose}
          />
        )}
      </div>
    </CustomDialog>
  );
};

export default AuthPopup; 